import { CompleteDealRecordKeeping } from '@/components/dialogs/CompleteDealDialog/CompleteDealRecordKeeping';
import { getPipelineName } from '@/components/dialogs/CompleteDealDialog/data';
import { usePipelineContext } from '@/context/pipelineContext';
import { useObjectContext } from '@/hooks/useObjectContext';
import { DialogTitle, useTheme } from '@mui/material';
import React, { useMemo } from 'react';

const CompleteDealHeader = () => {
	const { dealRow } = useObjectContext();
	const { pipeline, stages } = usePipelineContext(dealRow?.pipeline);

	const currentStage = stages.find((s) => s.id === dealRow?.dealStage);

	const isEndorsementStage = useMemo(() => currentStage?.isEndorsement, [currentStage]);

	const theme = useTheme();
	const pipelineName = useMemo(
		() => getPipelineName(pipeline, isEndorsementStage),
		[pipeline, isEndorsementStage],
	);

	return (
		<DialogTitle
			sx={{ fontWeight: 'bold', borderBottom: `1px solid ${theme.palette.divider}` }}
			component='div'
		>
			{`Complete ${pipelineName}`}
		</DialogTitle>
	);
};
CompleteDealHeader.displayName = 'CompleteDealHeader';
export default CompleteDealHeader;
